export default __webpack_public_path__ + "static/ElieC-127af120e65305afa36e1838c6130296.png";